export const MAX_TABLE_ITEMS = 20;
export const MIN_ITEMS_FOR_SCROLL = 5;
export const NUMBER_OF_INPUT_DIMENSIONS = {
  QUANTITY_1: '1',
  QUANTITY_2: '2',
  QUANTITY_3: '3',
  QUANTITY_4: '4',
  QUANTITY_5: '5',
  QUANTITY_6: '6',
};
